/*
 * @Author: zjw
 * @Date: 2021-06-10 15:48:26
 * @LastEditTime: 2022-11-16 16:24:39
 * @FilePath: \web-app\src\network\other\about.js
 * @Environment: Vue + Element
 * @Description: 关于我们
 */
import {
    request,
} from '../request.js'

// 列表
export function aboutList(data) {
    return request({
        url: '/web/back/aboutUs/list',
        method: 'post',
        data
    })
}

// 修改
export function editAbout(data) {
    return request({
        url: '/web/back/aboutUs/update',
        method: 'post',
        data
    })
}

// 添加  
export function addAbout(data) {
    return request({
        url: '/web/back/aboutUs/add',
        method: 'post',
        data
    })
}